window.TSUtils = {};

TSUtils.MEMBER_TYPES = {};
TSUtils.MEMBER_TYPES.EMPLOYER = "employer";
TSUtils.MEMBER_TYPES.EMPLOYEE = "employee";

TSUtils.MAXIMUM_EDITABLE_WEEKS = 2;
